<style scoped>
.VueCarousel-slide {
  visibility: visible;
}
.VueCarousel {
  width: 100%;
  height: 100%;
}
</style>
<template>
  <div>
    <div class="hidden sm:block" style="direction: ltr !important">
      <carousel
        :perPage="1"
        :paginationPosition="'bottom-overlay'"
        :navigationEnabled="true"
        navigationNextLabel="<i class='fa fa-arrow-right'></i>"
        navigationPrevLabel="<i class='fa fa-arrow-left'></i>"
      >
        <slide v-for="i in 3" :key="i">
          <div class="oneSlide">
            <img :src='"/Images/"+i+Lang+".jpg"' alt="The Company" />
            <div class="info hidden">
              <h3>{{ $t("Section.Company") }}</h3>
              <a href="#Company" class="siteBtn">{{ $t("Explore") }}</a>
            </div>
          </div>
        </slide>
       
      </carousel>
    </div>
    <div class="block sm:hidden" style="direction: ltr !important">
      <carousel
        :perPage="1"
        :paginationPosition="'bottom-overlay'"
        :navigationEnabled="true"
        navigationNextLabel="<i class='fa fa-arrow-right'></i>"
        navigationPrevLabel="<i class='fa fa-arrow-left'></i>"
      >
        <slide v-for="i in 3" :key="i">
          <div class="oneSlide">
            <img :src='"/Images/"+i+"M"+Lang+".jpg"' alt="The Company" />
            <div class="info hidden">
              <h3>{{ $t("Section.CompanyTitle") }}</h3>
              <a href="#Company" class="siteBtn">{{ $t("Explore") }}</a>
            </div>
          </div>
        </slide>
       
      </carousel>
    </div>

    <div id="Company" class="Company">
      <div class="wrapper shadow-lg rounded-md my-2">
        <div>
          <h2 class="text-2xl font-bold mb-4">
            {{ $t("Section.CompanyTitle") }}
          </h2>
          <div v-html="$t('Section.CompanyText')"></div>
          <br />
          <h2 class="text-2xl font-bold mb-4">
            {{ $t("Section.MissionTitle") }}
          </h2>
          <div>
            <p>
              {{ $t("Section.MissionText") }}
            </p>
          </div>
          <br />
          <h2 class="text-2xl font-bold mb-4">
            {{ $t("Section.VisionTitle") }}
          </h2>
          <div>
            <p>
              {{ $t("Section.VisionText") }}
            </p>
          </div>
        </div>
        <div>
          <img src="/Images/3-01.png" alt="The Company" />
        </div>
      </div>
    </div>
    <div id="Catalog" class="Catalog my-10">
  <div class="wrapper rounded-md my-2 p-4">
    <h2 class="text-2xl font-bold mb-4">
      {{ $t("books.BooksTitle") }}
    </h2>

    <!-- Grid Container -->
    <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
      
      <div v-for="i in bookNum" :key="i + 'b'" class="relative group flex justify-center items-center">
        
        <!-- Router Link -->
        <router-link :to="`/books/${i}`" class="block w-full h-full flex justify-center items-center">
          
          <!-- Book Cover Image -->
          <div class="w-full flex justify-center items-center rounded-md overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 transform group-hover:scale-105 bg-gray-100 p-2">
            <img 
              :src="`/Images/b${i}.jpg`"
              :alt="`Book ${i}`"
              class="max-w-full max-h-96 object-contain rounded-md"
            />
          </div>

        </router-link>

      </div>

    </div>
  </div>
</div>

    <div id="Project" class="Project">
      <div class="wrapper shadow-lg rounded-md my-2">
        <h2 class="text-2xl font-bold mb-4">
            {{ $t("Section.Project") }}
          </h2>

          <div class="lg:grid grid-cols-5">
            <div class="col-span-3"  v-html="$t('Section.ProjectText')" ></div>
            <div class="justify-self-center col-span-2 "><img src="/Images/books.png" style="width:400px" alt="Translated books" class="mx-auto pt-5 lg:pt-0"></div>
          </div>
      </div>
    </div>
    <div id="Voice" class="Voice">
      <div class="wrapper rounded-md my-5">
        
        <div class="mt-5">
          <h2 class="text-2xl font-bold mb-4">
            {{ $t("Section.VoiceTitle") }}
          </h2>
          <div v-html="$t('Section.VoiceText')"></div>
          
        </div>
        <a href="https://agoravoice.site/" target="_blank" class="siteBtn ms-0 my-5">{{ $t("Explore") }}</a>
      </div>
    </div>
    <div id="Why" class="Why">
      <div class="wrapper shadow-lg rounded-md my-5">
        <div>
          <img src="/Images/1-01.png" alt="Team " />
        </div>
        <div class="mt-5">
          <h2 class="text-2xl font-bold mb-4">
            {{ $t("Section.WhyTitle") }}
          </h2>
          <div v-html="$t('Section.WhyText')"></div>
        </div>
      </div>
    </div>

    
    <div id="Contact" class="Contact">
      <div class="wrapper shadow-lg rounded-md my-5">
        <div>
          <form @submit.prevent="sendEmail" ref="form" id="contactForm">
            <h2 class="text-2xl font-bold mb-2">
              {{ $t("Section.ContactTitle") }}
            </h2>

            <div class="aboveForm">
              <p>
                {{ $t("ContactForm.Heading") }}
                <br>
                <br>
                <span>{{ $t("ContactForm.subheading") }}</span>
                <br>
              </p>

              <div class="text-xs">
                <br>
                <p class="font-bold" v-html="$t('ContactForm.working')"> </p>
                <br />
                <h3 class="font-bold text-lg siteColor" v-html="$t('ContactForm.Iraq.name')"> </h3>
                <br>
                <span class="text-sm" v-html="$t('ContactForm.Iraq.address')"> </span>
                
                <br>
                <span class="text-sm font-bold">
                  <a href="tel:009647702000545">{{
                    $t("ContactForm.PhoneOne")
                  }}</a>
                  |
                  <a href="tel:009647502000545">{{
                    $t("ContactForm.PhoneTwo")
                  }}</a>
                </span>
                <br>
                <br>
                <h3 class="font-bold text-lg siteColor" v-html="$t('ContactForm.Canada.name')"> </h3>
                <br>
                <span class="text-sm" v-html="$t('ContactForm.Canada.address')"> </span>
                <br>
                <span class="text-sm font-bold">
                  <a href="tel:0017767781476">{{
                    $t("ContactForm.PhoneCanada")
                  }}</a>
                  
                </span>
                <br>
               
                
              </div>
            
              <br>
              <p>{{ $t("ContactForm.Sub") }}</p>
            </div>
            <label for="user_name"> {{ $t("ContactForm.Name") }} </label>
            <input
              required
              v-model="contact.name"
              type="text"
              name="user_name"
              class="
                block
                w-full
                h-8
                rounded
                shadow-lg
                my-2
                px-2
                outline-none
                transition
                hover:shadow-md
              "
            />
            <label for="user_email">{{ $t("ContactForm.Email") }} </label>
            <input
              required
              v-model="contact.mail"
              type="email"
              name="user_email"
              class="
                block
                w-full
                h-8
                rounded
                shadow-lg
                my-2
                px-2
                outline-none
                transition
                hover:shadow-md
              "
            />
            <label for="user_phone"> {{ $t("ContactForm.Phone") }} </label>
            <input
              required
              v-model="contact.phone"
              type="tel"
              name="user_phone"
              class="
                block
                w-full
                h-8
                rounded
                shadow-lg
                my-2
                px-2
                outline-none
                transition
                hover:shadow-md
              "
            />
            <label for="message" class="block">
              {{ $t("ContactForm.Message") }}
            </label>
            <textarea
              required
              v-model="contact.message"
              name="message"
              class="
                block
                w-full
                h-24
                rounded
                shadow-lg
                my-2
                px-2
                outline-none
                transition
                hover:shadow-md
              "
            ></textarea>
            <button
              class="
                mt-3
                block
                bg-blue-500
                hover:bg-blue-700
                text-white
                font-bold
                py-2
                px-4
                rounded
                transition
              "
            >
              {{ $t("Send") }}
            </button>
          </form>
        </div>
        <div class="w-50">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3245.5323177804235!2d45.432587515609875!3d35.56525094393079!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40002dc3c9af9dcb%3A0x1382709528a56a1e!2zQWdvcmEgVmlzaW9uINim2Kfar9uG2LHYpyDapNuM2pjZhg!5e0!3m2!1sen!2siq!4v1657790412965!5m2!1sen!2siq"
            style="border: 0"
            allowfullscreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//Service ID service_it8ziaq
//Template ID template_fro9gmk
//user ID user_Mhdpo0N7SP8VnDjdVXPda

import { Carousel, Slide } from "vue-carousel";
import emailjs from "@emailjs/browser";
import { mapGetters } from "vuex";
export default {
  computed: mapGetters([
    "getCurrentLocale",
    "getCurrentDir",
  
    "Lang",
  ]),
  name: "Home",
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      bookNum :5,
      filteredPosts: null,
      contact: {
        name: null,
        mail: null,
        phone: null,
        message: null,
      },
    };
  },
  methods: {
    sendEmail() {
      this.$loading(true);
      emailjs
        .sendForm(
          "service_it8ziaq",
          "template_fro9gmk",
          this.$refs.form,
          "user_Mhdpo0N7SP8VnDjdVXPda"
        )
        .then(
          (result) => {
            console.log(result);
            this.contact = {
              name: null,
              mail: null,
              phone: null,
              message: null,
            };
            this.$loading(false);
            this.$vToastify.success(
              this.getCurrentLocale == "ku"
                ? "ئیمەیڵ بە سەرکەوتوویی نێردرا."
                : "Email was sent successfully.",
              this.getCurrentLocale == "ku" ? "سەرکەوتن!" : "Success!"
            );
          },
          (error) => {
            console.log(error);
            this.$loading(false);
            this.$vToastify.error(
              this.getCurrentLocale == "ku"
                ? "تکایە پەیوەندی بکە بە سەرپەرشتیاری وێب سایتەوە."
                : "Please contact website administrator.",
              this.getCurrentLocale == "ku"
                ? "هەڵەیەک ڕوویدا."
                : "An error occurred."
            );
          }
        );
    },
  },
  mounted() {
    //this.$loading(true);

    
  },
};
</script>
